export const SINGLE_ITEM_TOAST_MESSAGE_FORMAT = "+ {0}";

export const MULTIPLE_ITEMS_TOAST_MESSAGE_FORMAT = "+ {0} and {1} more";
